import {
  loginByUsername,
  logout,
  getUserInfo,
  loginBySms,
  loginByMp,
  bindUser
} from '@/api/login'
import {
  getToken,
  setToken,
  removeToken
} from '@/utils/auth'

const user = {
  state: {
    user: '',
    status: '',
    code: '',
    token: getToken(),
    id: '',
    name: '',
    avatar: '',
    introduction: '',
    timezone: '',
    notReviews: '',
    score: '',
    roles: [],
    setting: {
      articlePlatform: []
    },
    subjectType: ''
  },

  mutations: {
    SET_CODE: (state, code) => {
      state.code = code
    },
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_INTRODUCTION: (state, introduction) => {
      state.introduction = introduction
    },
    SET_SETTING: (state, setting) => {
      state.setting = setting
    },
    SET_STATUS: (state, status) => {
      state.status = status
    },
    SET_ID: (state, id) => {
      state.id = id
    },
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_TIMEZONE: (state, timezone) => {
      state.timezone = timezone
    },
    SET_NOTREVIEWS: (state, notReviews) => {
      state.notReviews = notReviews
    },
    SET_SCORE: (state, score) => {
      state.score = score
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    },
    SET_SUBJECTTYPE: (state, subjectType) => {
      state.subjectType = subjectType
    }
  },

  actions: {
    // 用户名登录
    LoginByUsername({
      commit
    }, userInfo) {
      const username = userInfo.username.trim();
      commit('SET_TOKEN', '')
      removeToken()
      return new Promise((resolve, reject) => {
        loginByUsername(username, userInfo.password).then(response => {
          if (response.status === 200 && response.data.code === 200) {
            const data = response.data.data
            commit('SET_TOKEN', 'Bearer ' + data.access_token)
            setToken('Bearer ' + data.access_token)
          }
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    LoginBySms({ commit }, userInfo) {
      const username = userInfo.username.trim()
      commit('SET_TOKEN', '')
      removeToken()
      return new Promise((resolve, reject) => {
        loginBySms(username, userInfo.verifyCode).then(response => {
          if (response.status === 200 && response.data.code === 200) {
            const data = response.data.data
            commit('SET_TOKEN', 'Bearer ' + data.access_token)
            setToken('Bearer ' + data.access_token)
          }
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    LoginByMp({ commit }, userInfo) {
      commit('SET_TOKEN', '')
      removeToken()
      return new Promise((resolve, reject) => {
        loginByMp(userInfo).then(response => {
          if (response.status === 200 && response.data.code === 200) {
            const data = response.data.data
            commit('SET_TOKEN', 'Bearer ' + data.access_token)
            setToken('Bearer ' + data.access_token)
          }
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    BindUser({ commit }, userInfo) {
      commit('SET_TOKEN', '')
      removeToken()
      return new Promise((resolve, reject) => {
        bindUser(userInfo).then(response => {
          if (response.status === 200 && response.data.code === 200) {
            const data = response.data.data
            commit('SET_TOKEN', 'Bearer ' + data.access_token)
            setToken('Bearer ' + data.access_token)
          }
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 获取用户信息
    GetUserInfo({
      commit,
      state
    }) {
      return new Promise((resolve, reject) => {
        getUserInfo().then(response => {
          const data = response.data.data;
          commit('SET_ID', data.id);
          commit('SET_NAME', data.name);
          commit('SET_STATUS', data.status);
          commit('SET_AVATAR', data.avatarUrl);
          commit('SET_INTRODUCTION', data.introduction);
          commit('SET_TIMEZONE', data.timezone);
          commit('SET_NOTREVIEWS', data.notReviewsLessonsCount);
          commit('SET_SCORE', data.avgStar);
          commit('SET_SUBJECTTYPE', data.subjectType);
          resolve(response);
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 登出
    LogOut({
      commit,
      state
    }) {
      return new Promise((resolve, reject) => {
        logout(state.token).then(() => {
          commit('SET_TOKEN', '')
          commit('SET_ROLES', [])
          removeToken()
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 前端 登出
    FedLogOut({
      commit
    }) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '')
        removeToken()
        resolve()
      })
    },
    // 动态修改权限
    ChangeRole({
      commit
    }, role) {
      return new Promise(resolve => {
        commit('SET_TOKEN', role)
        setToken(role)
        getUserInfo(role).then(response => {
          const data = response.data
          commit('SET_ROLES', data.role)
          commit('SET_NAME', data.name)
          commit('SET_AVATAR', data.avatar)
          commit('SET_INTRODUCTION', data.introduction)
          resolve()
        })
      })
    }
  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js